import {
  Flex,
  VStack,
  Button,
  useDisclosure,
  Icon,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useEditState from '../../../../../../common/src/hooks/useEditState';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { Accident } from '../../../../types/CompanyScanTypes';
import AccidentsTable from './AccidentsTable';
import NewAccidentModal from './NewAccidentModal';

interface Props {
  question: FlowsQuestion;
}

const AccidentInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();

  const { toBeEdited, setToBeEdited, editIndex, setEditIndex } =
    useEditState<Accident>();

  const {
    field: { value, onBlur },
    // error,
  } = useFlowInputComponent({ question, defaultValue: [] });

  const accidents = (value as Accident[] | undefined) || [];

  const addAccident = (accident: Accident) => {
    onBlur({ name: question.id, value: [...accidents, accident] });
  };

  const editAccident = (accident: Accident, index: number) => {
    if (index > -1) {
      const newAccidents = [...accidents];
      newAccidents[index] = accident;
      onBlur({ name: question.id, value: newAccidents });
    }
  };

  const handleOnRemove = (index: number) => {
    onBlur({
      name: question.id,
      value: accidents.filter((_, _index) => _index !== index),
    });
  };

  const handleOnEdit = (accident: Accident) => {
    setToBeEdited(accident);
    onOpen();
  };

  const handleOnClose = () => {
    setToBeEdited(undefined);
    setEditIndex(undefined);
    onClose();
  };

  return (
    <VStack spacing="4" align="stretch">
      {isOpen && (
        <NewAccidentModal
          accident={toBeEdited}
          isOpen={isOpen}
          onClose={handleOnClose}
          addAccident={addAccident}
          editAccident={(accident) => editAccident(accident, editIndex || 0)}
        />
      )}
      <AccidentsTable
        accidents={accidents}
        onEdit={handleOnEdit}
        onRemove={handleOnRemove}
      />
      <Flex justify="flex-end">
        <Button
          onClick={onOpen}
          leftIcon={<Icon name="GeneralActionsAdd" />}
          isDisabled={question.rules.is_disabled}
        >
          {t('FLOWS_COMPANY-SCAN_ACCIDENT-INPUT_ADD-ACCIDENT')}
        </Button>
      </Flex>
    </VStack>
  );
};

export default AccidentInputComponent;
